import large1 from './images/car-icons/1_large.png';
import big1 from './images/car-icons/1_big.png';
import normal1 from './images/car-icons/1_normal.png';
import dot1 from './images/car-icons/1_dot.png';

import large2 from './images/car-icons/2_large.png';
import big2 from './images/car-icons/2_big.png';
import normal2 from './images/car-icons/2_normal.png';
import dot2 from './images/car-icons/2_dot.png';

import large3 from './images/car-icons/3_large.png';
import big3 from './images/car-icons/3_big.png';
import normal3 from './images/car-icons/3_normal.png';
import dot3 from './images/car-icons/3_dot.png';

import large4 from './images/car-icons/4_large.png';
import big4 from './images/car-icons/4_big.png';
import normal4 from './images/car-icons/4_normal.png';
import dot4 from './images/car-icons/4_dot.png';

import large5 from './images/car-icons/5_large.png';
import big5 from './images/car-icons/5_big.png';
import normal5 from './images/car-icons/5_normal.png';
import dot5 from './images/car-icons/5_dot.png';

import large6 from './images/car-icons/6_large.png';
import big6 from './images/car-icons/6_big.png';
import normal6 from './images/car-icons/6_normal.png';
import dot6 from './images/car-icons/6_dot.png';

import large7 from './images/car-icons/7_large.png';
import big7 from './images/car-icons/7_big.png';
import normal7 from './images/car-icons/7_normal.png';
import dot7 from './images/car-icons/7_dot.png';

import large8 from './images/car-icons/8_large.png';
import big8 from './images/car-icons/8_big.png';
import normal8 from './images/car-icons/8_normal.png';
import dot8 from './images/car-icons/8_dot.png';

export default {
  large1,
  big1,
  normal1,
  dot1,
  large2,
  big2,
  normal2,
  dot2,
  large3,
  big3,
  normal3,
  dot3,
  large4,
  big4,
  normal4,
  dot4,
  large5,
  big5,
  normal5,
  dot5,
  large6,
  big6,
  normal6,
  dot6,
  large7,
  big7,
  normal7,
  dot7,
  large8,
  big8,
  normal8,
  dot8,
};
